import { Center, Flex, Text } from '@chakra-ui/react';
import { ReplyIcon } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

interface MessageRepliesProps {
  count: number;
}

export function MessageReplies({ count }: MessageRepliesProps) {
  const { t } = useTranslation();
  if (!count) {
    return null;
  }

  return (
    <Flex className="MessageReplies" gap="1" align="center">
      <Center color="brand.100">
        <ReplyIcon />
      </Center>
      <Text fontSize="xs" color="brand.100" fontWeight="semibold">
        {count} {t('action.reply')}
      </Text>
    </Flex>
  );
}
